import * as React from 'react';
import { useMediaState } from '@platejs/media/react';
import { ResizableProvider } from '@platejs/resizable';
import { FileUp } from 'lucide-react';
import { PlateElement, useReadOnly, withHOC } from 'platejs/react';

import { cn } from 'src/lib/utils';

export const FileElement = withHOC(ResizableProvider, function FileElement(props: any) {
  const readOnly = useReadOnly();
  const { name, unsafeUrl } = useMediaState();

  return (
    <PlateElement className="my-px rounded-sm" {...props}>
      <a
        className={cn(
          'group relative m-0 flex cursor-pointer items-center rounded px-0.5 py-[3px] hover:bg-muted',
        )}
        contentEditable={false}
        download={name}
        href={unsafeUrl}
        rel="noopener noreferrer"
        role="button"
        target="_blank"
      >
        <div className={cn('flex items-center gap-1 p-1')}>
          <FileUp className="size-5" />
          <div>{name}</div>
        </div>
      </a>
      {props.children}
    </PlateElement>
  );
});
